import Constants from '../constants/PassengersConstants';
import PassengersRemoting from '../../remoting/PassengersRemoting';
import StatusCodes from '../../model/StatusCodes';

/**
 *
 * @param {*} type - type constant (string)
 * @param {*} data - object, list or string
 */
function dispatchToReducer (type, data) {
  return {
    type: type,
    data: data,
  };
}

/**
 * getSessionToken called on client getting session token and saving it to cookie
 */
export function getPassengers (reservationId) {
  return dispatch => {
    dispatch(dispatchToReducer(Constants.PASSENGERS_REQUEST));
    PassengersRemoting.getPassengers(reservationId)
      .then(response => {
        if (response && response.status === StatusCodes.UNKNOWN_ERROR) {
          console.error('Error occured: ', response.message);
          return dispatch(dispatchToReducer(Constants.PASSENGERS_FAILURE, response));
        }
        if (response && response.status === StatusCodes.OK) {
          if (response.data.passengers) {
            return dispatch(
              dispatchToReducer(Constants.PASSENGERS_SUCCESS, response.data.passengers)
            );
          }
        }
      })
      .catch(error => {
        console.error('Error occured: ', error);
        return dispatch(dispatchToReducer(Constants.PASSENGERS_FAILURE, error));
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/PassengersActions.js